'use strict';

exports.__esModule = true;
exports['default'] = ownKeys;

function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/ownKeys.js
// module id = 1471
// module chunks = 0